import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="font-heading text-lg font-semibold text-foreground-900 mb-4">
              VigorBuy Spreadsheet
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Your complete resource for professional spreadsheet templates, business productivity tools, and data management solutions.
            </p>
            <div className="flex gap-3 mt-5">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-4 py-2 text-xs font-semibold rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                Visit Main Site
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              Categories
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.seq}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              More Categories
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(7).map((cat) => (
                <li key={cat.seq}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
              Resources
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/vigorbuy-spreadsheet-guide"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  Complete Guide
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Official Store
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} VigorBuy Spreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap">
              Home
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Main Website
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}